import React, { Component } from 'react'
import {
    Row, Col, Alert, Progress, Button, Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap'
import gql from 'graphql-tag'
import withApolloClient from '../withApolloClient'
import './RepAssignmentModal.css'

const ChargeBadDebtDriversMutation = gql`
    mutation ChargeBadDebtDrivers($input: ChargeBadDebtDriversMutationInput!) {
        chargeBadDebtDrivers(input: $input) {
            ok
            errors {
                field
                messages
            }
            successMessage
        }
    }
`

class BadDebtChargeModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            error: null,
            chargeSuccess: false,
            successMessage: null
        }
    }

    chargeDrivers = () => {
        this.setState({ loading: true, error: null, chargeSuccess: false })

        const input = {
            driverIds: this.props.selectedDrivers.length > 0 ? this.props.selectedDrivers : null
        }

        this.props.apolloClient.mutate({
            mutation: ChargeBadDebtDriversMutation,
            variables: { input }
        }).then(result => {
            const data = result.data?.chargeBadDebtDrivers
            if (data?.ok) {
                this.setState({
                    loading: false,
                    chargeSuccess: true,
                    successMessage: data.successMessage || "Bad debt charging initiated successfully!",
                    error: null
                })
                if (this.props.refetchQuery) {
                    this.props.refetchQuery()
                }
            } else {
                const errorMsg = data?.errors?.length > 0
                    ? data.errors.map(e => e.messages.join(', ')).join('; ')
                    : "Failed to charge bad debt"
                this.setState({ loading: false, error: errorMsg, chargeSuccess: false })
            }
        }).catch(error => {
            this.setState({ 
                loading: false, 
                error: error.toString() || "An error has occurred", 
                chargeSuccess: false 
            })
        })
    }

    render() {
        const { selectedDrivers } = this.props
        const hasSelection = selectedDrivers && selectedDrivers.length > 0
        const driverCount = hasSelection ? selectedDrivers.length : "all"

        return (
            <div>
                <Modal className="badDebtChargeModal modal-dialog-centered" isOpen={this.props.open}>
                    <ModalHeader style={{ justifyContent: "center" }}>
                        {hasSelection 
                            ? `Charge Bad Debt for ${selectedDrivers.length} Selected Driver${selectedDrivers.length > 1 ? 's' : ''}`
                            : "Charge Bad Debt for All Drivers"
                        }
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            {hasSelection && !this.state.error && !this.state.chargeSuccess && (
                                <Col xs={12}>
                                    <p style={{ fontSize: "1.2rem", color: "green" }}>
                                        {selectedDrivers.length} driver{selectedDrivers.length > 1 ? 's' : ''} selected to be charged!
                                    </p>
                                </Col>
                            )}
                            {this.state.error && (
                                <Col xs={12}>
                                    <Alert color="danger">{this.state.error}</Alert>
                                </Col>
                            )}
                            {this.state.chargeSuccess ? (
                                <Col xs={12}>
                                    <Alert color="success">
                                        {this.state.successMessage || "Bad debt charging started successfully! You will be notified once this process is complete."}
                                    </Alert>
                                </Col>
                            ) : (
                                <>
                                    <Col xs={12}>
                                        <p style={{ fontSize: "1rem", marginBottom: "1rem" }}>
                                            {hasSelection 
                                                ? `You are about to charge ${driverCount} selected driver${selectedDrivers.length > 1 ? 's' : ''} for their bad debt.`
                                                : "You are about to charge all drivers with bad debt."
                                            }
                                        </p>
                                        <p style={{ fontSize: "1rem", marginBottom: "1rem" }}>
                                            This action will attempt to charge each driver's payment method on file for the full amount of their bad debt write-off. 
                                            If the full amount fails, the system will automatically retry with 50% and then 25% of the amount.
                                        </p>
                                    </Col>
                                    <Col xs={12}>
                                        <Alert color="info">
                                            <strong>Note:</strong> Only <b>inactive</b> drivers <b>without active payment plans</b> and <b>scheduled payments</b> will be charged. 
                                            Drivers must have a <b>valid payment method</b>.
                                        </Alert>
                                    </Col>
                                </>
                            )}
                        </Row>
                        {this.state.loading && (
                            <Row>
                                <Col xs={12}>
                                    <Progress animated color="info" value="100" />
                                </Col>
                            </Row>
                        )}
                    </ModalBody>
                    <ModalFooter>
                        {!this.state.loading && (
                            <Row>
                                <Col xs={12}>
                                    <Button 
                                        outline 
                                        color="secondary" 
                                        onClick={this.props.handleClose}
                                    >
                                        Close
                                    </Button>
                                    &nbsp;&nbsp;
                                    {!this.state.chargeSuccess && (
                                        <Button 
                                            color="danger" 
                                            onClick={this.chargeDrivers}
                                            disabled={this.state.loading}
                                        >
                                            Charge Customers
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        )}
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default withApolloClient(BadDebtChargeModal)
